var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import { DatePicker, Input } from 'elements';
import { toDate } from '../helpers/Format';
import PropTypes from 'prop-types';
var FieldDate = /** @class */ (function (_super) {
    __extends(FieldDate, _super);
    function FieldDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOpen = function () {
            if (_this.props.onOpen) {
                _this.props.onOpen();
            }
            _this.visible = true;
        };
        _this.handleClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
            _this.visible = false;
        };
        return _this;
    }
    FieldDate.prototype.componentDidMount = function () {
        this.visible = this.props.opened;
    };
    FieldDate.prototype.render = function () {
        var _this = this;
        var _a = this.props, date = _a.date, name = _a.name, withTime = _a.withTime, required = _a.required, mode = _a.mode, startDay = _a.startDay, endDay = _a.endDay, disabled = _a.disabled, onChange = _a.onChange;
        return (React.createElement("div", null,
            React.createElement(WrapperContainer, { flex: !!date },
                React.createElement(Label, { onClick: function () {
                        var _a, _b;
                        if (_this.visible) {
                            (_a = _this.picker) === null || _a === void 0 ? void 0 : _a.picker.close();
                        }
                        else {
                            (_b = _this.picker) === null || _b === void 0 ? void 0 : _b.picker.open();
                        }
                    } },
                    t(name) + (required ? '*' : ''),
                    React.createElement(Input, { type: 'text', value: date ? toDate(date) : '', disabled: disabled })),
                date && React.createElement(WrapperI, { className: "cui-trash", onClick: function () { return onChange(name, null); } })),
            React.createElement(DatePicker, { ref: function (ref) { return _this.picker = ref; }, mode: mode, name: name, date: date, withTime: withTime, startDay: startDay, endDay: endDay, onChange: onChange, onOpen: this.handleOpen, onClose: this.handleClose })));
    };
    return FieldDate;
}(Component));
export default FieldDate;
var WrapperContainer = cxs('div')(function (_a) {
    var flex = _a.flex;
    if (flex) {
        return {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        };
    }
    return {};
});
var Label = cxs('label')({
    padding: Theme.size.space[1],
    color: Theme.color.placeholder,
    width: '100%'
});
var WrapperI = cxs('i')({
    marginRight: '10px'
});
WrapperContainer.propTypes = {
    flex: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldDate.tsx
// module id = 1012
// module chunks = 0